import { Injectable } from "@angular/core";
import * as filesaver from 'file-saver';

@Injectable()
export class Downloader {
  constructor() {}

  private base64ToArrayBuffer(base64: string): any {
    let binaryString = window.atob(base64);
    let length = binaryString.length;
    let bytes = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  // Method for base64 download
  public getFile(file: any): void {
    let fileContent = file.fileContent;
    let blob = new Blob([this.base64ToArrayBuffer(fileContent)], {
      type: "application/octet-stream",
    });
    filesaver.saveAs(blob, file.fileName);
  }

  //Arraybufffer method
  public getFileV2(file: any): void {
    let blob = new Blob([file.fileContent], {
      type: file.fileType !== '' && file.fileType !==  null && file.fileType !==  undefined ? file.fileType : "application/zip; charset=utf-8",
    });
    filesaver.saveAs(blob, file.fileName);
  }

  public getFileV2NoClick(file: any): void {
    let blob = new Blob([file.fileContent], {
      type: file.fileType !== '' && file.fileType !==  null && file.fileType !==  undefined ? file.fileType : "application/zip; charset=utf-8",
    });
    let fileData = URL.createObjectURL(blob);
    window.open(fileData);
  }
}
